<div class="flex flex-col gap-2 bg-surface p-3 rounded-[var(--app-radius-md)] border border-gray-200 shadow-lg min-w-[15rem] max-w-[24rem]">
	<div class="text-[0.68rem] font-bold uppercase tracking-wide text-gray-500">{{ history().label }}</div>
	@for (entry of history().entries; track $index) {
		<div class="flex items-center gap-2" [class.font-semibold]="entry.status === 'today'">
			<mat-icon
				fontSet="material-symbols-outlined"
				class="!text-[16px] !w-4 !h-4 shrink-0"
				[class.text-gray-500]="entry.status !== 'today'"
				[style.color]="entry.status === 'today' ? 'rgba(var(--color-primary), 1)' : null">
				{{ statusIcon(entry.status) }}
			</mat-icon>
			<ara-generic-chip [label]="entry.period" [tone]="entry.status === 'today' ? 'primary' : 'neutral'"></ara-generic-chip>
			<span class="text-sm">{{ entry.name }}</span>
		</div>
	}
</div>
